import type { FeatureCardGridFragment } from '@mnd-apps/public/wp-generated/types';
import FeatureCard from '@mnd-frontend/ui/public/components/FeatureCard';
import ContentMaxWidth from '@mnd-frontend/ui/public/components/wrappers/ContentMaxWidth';
import SectionHeader from '@mnd-frontend/ui/public/components/wrappers/SectionHeader';
import { Icons } from '@mnd-frontend/ui/publish/components';
import {
  BREAKPOINTS,
  SPACING_2,
  SPACING_3,
  SPACING_6,
  SPACING_10,
} from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';

const Section = styled.section`
  background: #F7F7F9; // @todo: use token
  padding: ${SPACING_6} ${SPACING_2};
  
  @media (min-width: ${BREAKPOINTS.XXL}px) { 
    padding: ${SPACING_10} 0;
  }
`;

const Grid = styled(ContentMaxWidth)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(20rem, 1fr));
  gap: ${SPACING_3};
`;

const FeatureCardModule = ({ data }: { data: FeatureCardGridFragment }) => {
  return (
    <Section>
      {data?.title && <SectionHeader headline={data.title} />}
      <Grid>
        {data?.cards?.map((card, index) => {
          const IconComponent = card?.icon?.[0]
            ? Icons[card.icon[0] as keyof typeof Icons]
            : Icons.Plane;
          return (
            <FeatureCard
              key={index}
              title={card?.title || ''}
              titleAs={data?.title ? 'h3' : 'h2'}
              icon={<IconComponent />}
              description={card?.description || ''}
              action={
                card?.link
                  ? {
                      text: card.link?.title || '',
                      href: card.link?.url || '',
                      newTab: card.link?.target === '_blank',
                    }
                  : undefined
              }
            />
          );
        })}
      </Grid>
    </Section>
  );
};

export default FeatureCardModule;
